import { useMemo } from 'react';
import { useLoaderData } from 'react-router';

import type { loader } from '~/routes/_app.product.$urlSegment';
import {
    DetailAwardsSection,
    toDetailAwards,
} from '~/ui-rocco/pages/detail-shared/DetailAwardsList';

/**
 * The product's awards, as a section of their own after the spec accordion:
 * the profile's awards list, standing open, rather than a row folded into
 * the accordion.
 */
export const ProductAwardsSection = ({ className }: { className?: string }) => {
    const { product } = useLoaderData<typeof loader>();
    const awards = useMemo(
        () => toDetailAwards(product.Awards),
        [product.Awards],
    );

    return <DetailAwardsSection awards={awards} className={className} />;
};
